function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M43.303 17.3338V8.76339C43.3031 7.1497 42.6656 5.60134 41.5294 4.45546C40.3932 3.30958 38.8503 2.659 37.2366 2.64539H28.6534",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3337 2.64539H8.76336C7.14077 2.64539 5.58463 3.28996 4.43728 4.43731C3.28993 5.58466 2.64536 7.1408 2.64536 8.76339V17.3338",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.6534 43.303H37.2366C38.8414 43.2896 40.3765 42.6461 41.5113 41.5113C42.6461 40.3766 43.2895 38.8414 43.303 37.2367V28.6534",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.64536 28.6534V37.2367C2.65897 38.8503 3.30955 40.3932 4.45543 41.5294C5.60131 42.6656 7.14967 43.3031 8.76336 43.303H17.3337",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2956 25.7363C19.9301 25.7363 20.4444 25.222 20.4444 24.5876C20.4444 23.9532 19.9301 23.4388 19.2956 23.4388C18.6612 23.4388 18.1469 23.9532 18.1469 24.5876C18.1469 25.222 18.6612 25.7363 19.2956 25.7363Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M26.6011 25.7363C27.2355 25.7363 27.7498 25.222 27.7498 24.5876C27.7498 23.9532 27.2355 23.4388 26.6011 23.4388C25.9667 23.4388 25.4524 23.9532 25.4524 24.5876C25.4524 25.222 25.9667 25.7363 26.6011 25.7363Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4444 24.5876H25.4394",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M27.8144 24.5876H28.0854L29.2342 24.2907C29.3297 24.2676 29.4148 24.213 29.4756 24.1358C29.5365 24.0586 29.5696 23.9631 29.5698 23.8648V23.5163C29.5652 23.4351 29.5334 23.3578 29.4794 23.2969L29.3891 23.1936C29.357 23.1639 29.3313 23.128 29.3136 23.0881C29.2958 23.0481 29.2864 23.005 29.2858 22.9613V22.7677C29.2861 22.6798 29.2622 22.5936 29.2166 22.5184C29.1711 22.4433 29.1057 22.3821 29.0277 22.3418V22.3418C28.5895 22.1357 28.1246 21.9923 27.6466 21.9158L26.4849 21.7222L24.4972 20.5864C24.1038 20.3634 23.6587 20.2477 23.2065 20.2508H21.0897C20.6385 20.2664 20.1968 20.3856 19.799 20.5993L18.0565 21.5415L17.2563 21.6319C17.1354 21.6502 17.0249 21.7109 16.9445 21.803C16.8642 21.8952 16.8191 22.013 16.8175 22.1352V22.6515C16.812 22.7769 16.7813 22.8998 16.7271 23.0129L16.6497 23.1678C16.588 23.2828 16.5569 23.4117 16.5593 23.5421V23.8777C16.5596 23.9839 16.5935 24.0873 16.6561 24.173C16.7187 24.2588 16.8068 24.3226 16.9078 24.3553L17.3725 24.4973C17.6423 24.5907 17.9258 24.6386 18.2114 24.6392",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0289 39.2889C14.9658 39.2889 17.3466 36.9081 17.3466 33.9711C17.3466 31.0342 14.9658 28.6534 12.0289 28.6534C9.09196 28.6534 6.71112 31.0342 6.71112 33.9711C6.71112 36.9081 9.09196 39.2889 12.0289 39.2889Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0289 36.3203C11.8406 36.3203 11.66 36.395 11.5269 36.5282C11.3938 36.6613 11.319 36.8419 11.319 37.0301C11.3054 37.1305 11.3134 37.2326 11.3425 37.3297C11.3716 37.4267 11.4211 37.5163 11.4878 37.5926C11.5544 37.6689 11.6366 37.7301 11.7288 37.772C11.821 37.8139 11.9211 37.8355 12.0224 37.8355C12.1237 37.8355 12.2238 37.8139 12.3161 37.772C12.4083 37.7301 12.4905 37.6689 12.5571 37.5926C12.6237 37.5163 12.6733 37.4267 12.7024 37.3297C12.7315 37.2326 12.7395 37.1305 12.7259 37.0301C12.7259 36.8441 12.6529 36.6655 12.5225 36.5327C12.3922 36.3999 12.2149 36.3236 12.0289 36.3203Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3448 30.8734V34.5907C11.3448 34.7687 11.4155 34.9394 11.5414 35.0652C11.6672 35.1911 11.838 35.2618 12.016 35.2618C12.194 35.2618 12.3647 35.1911 12.4906 35.0652C12.6164 34.9394 12.6871 34.7687 12.6871 34.5907V30.8734C12.6871 30.6954 12.6164 30.5247 12.4906 30.3988C12.3647 30.2729 12.194 30.2022 12.016 30.2022C11.838 30.2022 11.6672 30.2729 11.5414 30.3988C11.4155 30.5247 11.3448 30.6954 11.3448 30.8734Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
function SvgVehicleTooFar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleTooFar);
export default __webpack_public_path__ + "static/media/vehicle-too-far.096cd9af6b7347e418a84c9f31eae7d0.svg";
export { ForwardRef as ReactComponent };